module.exports = __webpack_public_path__ + "static/media/avatarTutLB.9d35b7b3.svg";